import {Router} from 'ninelines-router';
import scrollDepth from 'scroll-depth';
import vars from './globals';
import {spent15sec, hit, testFinished} from './components/analitycs';
import {initMainLifehacksAnimation, destroyMainLifehacksAnimation} from './components/lifehacks';
import {initArticleAnimation, destroyArticleAnimation} from './components/article-animation';
import {sortArticle, articleScroll, articleLeave} from './components/article-scroll';
import relatedSlider from './components/related';
import test from './components/test';
import products from './components/products';

let router = new Router();

let spent;

router.addRoute({
	path: '/',
	name: 'main',
	onEnter(prevState) {
		return new Promise((resolve) => {
			vars.$html.data('page', 'main').attr('data-page', 'main');

			TweenMax.set(vars.$body, {clearProps: 'all'});

			if (prevState.route) {
				new TimelineMax({
					onStart() {
						$('.page[data-page="main"]').removeClass('is-hidden').addClass('is-active');
						vars.$main.removeClass('is-hidden');
						vars.$siteContainer.removeClass('is-hidden');
					},
					onComplete() {
						clearTimeout(spent);
						spent = setTimeout(spent15sec, 15000);
						hit(location.pathname);
						scrollDepth.reset();

						initMainLifehacksAnimation();
						resolve();
					},
				})
					.from(vars.$siteContainer, 0.5, {
						autoAlpha: 0,
						clearProps: 'all',
					});
			} else {
				new TimelineMax({
					onStart() {
						$('.page[data-page="main"]')
							.removeClass('is-hidden')
							.addClass('is-active');
						vars.$main.removeClass('is-hidden');
						vars.$siteContainer.removeClass('is-hidden');
					},
					onComplete() {
						clearTimeout(spent);
						spent = setTimeout(spent15sec, 15000);

						initMainLifehacksAnimation();
						resolve();
					},
				})
					.from(vars.$siteContainer, 0.5, {
						autoAlpha: 0,
						clearProps: 'all',
					});
			}
		});
	},
	onLeave(currentState, nextState) {
		return new Promise((resolve) => {
			const isNextTest = nextState.route.name === 'test';

			if (isNextTest) {
				TweenMax.to(vars.$body, 0.15, {
					backgroundColor: '#000',
				});
			}

			new TimelineMax({
				onComplete() {
					vars.$page.addClass('is-hidden');

					destroyMainLifehacksAnimation();
					resolve();
				},
			})
				.to(vars.$siteContainer, 0.5, {
					autoAlpha: 0,
					clearProps: 'all',
				}, isNextTest ? 0.15 : 0);
		});
	},
});

router.addRoute({
	path: '/test',
	name: 'test',
	onEnter(prevState) {
		return new Promise((resolve) => {
			vars.$html.data('page', 'test').attr('data-page', 'test');
			let $page = $('.page[data-page="test"]');

			vars.$html
				.data('page', 'test')
				.attr('data-page', 'test');

			if (prevState.route) {
				if (!$page.length) {
					router.trigger('notFound', [location.pathname]);
				} else {
					new TimelineMax({
						onStart() {
							$('.aos-animate').removeClass('aos-animate');
							$page.removeClass('is-hidden').addClass('is-active');
							vars.$siteContainer.removeClass('is-hidden');

							test.initVideos();
							test.start();
						},
						onComplete() {
							clearTimeout(spent);
							spent = setTimeout(spent15sec, 15000);
							hit(location.pathname);
							scrollDepth.reset();

							TweenMax.set(vars.$body, {clearProps: 'all'});

							resolve();
						},
					})
						.from(vars.$siteContainer, 0.5, {
							autoAlpha: 0,
							clearProps: 'all',
						});
				}
			} else {
				Promise.resolve()
					.then(() => {
						if (!$page.length) {
							router.trigger('notFound', [location.pathname]);
						} else {
							new TimelineMax({
								onStart() {
									$page.removeClass('is-hidden').addClass('is-active');
									vars.$siteContainer.removeClass('is-hidden');

									test.initVideos();
									test.start();
								},
								onComplete() {
									clearTimeout(spent);
									spent = setTimeout(spent15sec, 15000);

									TweenMax.set(vars.$body, {clearProps: 'all'});

									resolve();
								},
							})
								.from(vars.$siteContainer, 0.5, {
									autoAlpha: 0,
									clearProps: 'all',
								});
						}
					});
			}
		});
	},
	onLeave() {
		return new Promise((resolve) => {
			new TimelineMax({
				onStart() {
				},
				onComplete() {
					vars.$page.addClass('is-hidden');
					$('.aos-animate').removeClass('aos-animate');

					test.clear();
					resolve();
				},
			})
				.to(vars.$siteContainer, 0.5, {
					autoAlpha: 0,
					clearProps: 'all',
				});
		});
	},
});

router.addRoute({
	path: '/article/:id',
	name: 'article',
	onEnter(prevState, currentState) {
		return new Promise((resolve) => {
			window.scrollTo(0, 0);

			let id = currentState.params.id;

			let $page = $(`.page[data-article="${id}"]`);

			vars.$html
				.data('page', 'article')
				.data('article', id)
				.attr('data-page', 'article')
				.attr('data-article', id);

			sortArticle();

			if (prevState.route) {
				if (!$page.length) {
					router.trigger('notFound', [location.pathname]);
				} else {
					new TimelineMax({
						onStart() {
							vars.$siteContainer.removeClass('is-hidden');
							vars.$article.removeClass('is-hidden');
							$page.addClass('is-active');

							relatedSlider.initSlider(id);
						},
						onComplete() {
							vars.pageScroll = 0;
							vars.articleCountScroll = 1;

							relatedSlider.updateSlider(id);

							articleScroll();

							initArticleAnimation();

							clearTimeout(spent);

							spent = setTimeout(spent15sec, 15000);

							hit(location.pathname);

							scrollDepth.reset();

							resolve();
						},
					}).from(vars.$siteContainer, 0.5, {
						autoAlpha: 0,
						clearProps: 'all',
					});
				}
			} else {
				Promise.resolve()
					.then(() => {
						if (!$page.length) {
							router.trigger('notFound', [location.pathname]);
						} else {
							new TimelineMax({
								onStart() {
									vars.$siteContainer.removeClass('is-hidden');
									vars.$article.removeClass('is-hidden');
									$page.addClass('is-active');

									relatedSlider.initSlider(id);
								},
								onComplete() {
									vars.pageScroll = 0;
									vars.articleCountScroll = 1;

									relatedSlider.updateSlider(id);

									articleScroll();

									initArticleAnimation();

									clearTimeout(spent);

									spent = setTimeout(spent15sec, 15000);

									resolve();
								},
							}).from(vars.$siteContainer, 0.5, {
								autoAlpha: 0,
								clearProps: 'all',
							});
						}
					});
			}
		});
	},
	onLeave(currentState, nextState) {
		return new Promise((resolve) => {
			let id = currentState.params.id;

			if (nextState && nextState.route.name === 'article' && nextState.route.id === id) {
				resolve();

				return;
			}

			new TimelineMax({
				onComplete() {
					vars.$body.removeAttr('style');
					vars.$siteContainer.addClass('is-hidden');
					vars.$article.addClass('is-hidden').removeAttr('style').removeClass('is-active');

					articleLeave();
					destroyArticleAnimation();

					resolve();
				},
			})
				.to(vars.$siteContainer, 0.5, {
					autoAlpha: 0,
					clearProps: 'all',
				});
		});
	},
});

router.addRoute({
	path: '/products',
	name: 'products',
	onEnter(prevState, currentState) {
		return new Promise((resolve) => {
			const id = currentState.query.id;
			vars.$html.data('page', 'products').attr('data-page', 'products');
			let $page = $('.page[data-page="products"]');

			vars.$html
				.data('page', 'products')
				.attr('data-page', 'products');

			products.createVideo();

			if (prevState.route) {
				if (!$page.length) {
					router.trigger('notFound', [location.pathname]);
				} else {
					new TimelineMax({
						onStart() {
							$page.removeClass('is-hidden').addClass('is-active');
							vars.$siteContainer.removeClass('is-hidden');

							if (id) {
								const $anchor = $page.find(`.product-block--${id}`);
								const offsetY = $anchor.offset().top;
								window.scrollTo(0, offsetY);
							}
						},
						onComplete() {
							clearTimeout(spent);
							spent = setTimeout(spent15sec, 15000);
							hit(location.pathname);
							scrollDepth.reset();

							resolve();
						},
					})
						.from(vars.$siteContainer, 0.5, {
							autoAlpha: 0,
							clearProps: 'all',
						});
				}
			} else {
				Promise.resolve()
					.then(() => {
						if (!$page.length) {
							router.trigger('notFound', [location.pathname]);
						} else {
							new TimelineMax({
								onStart() {
									$page.removeClass('is-hidden').addClass('is-active');
									vars.$siteContainer.removeClass('is-hidden');

									if (id) {
										const $anchor = $page.find(`.product-block--${id}`);
										const offsetY = $anchor.offset().top;
										window.scrollTo(0, offsetY);
									}
								},
								onComplete() {
									clearTimeout(spent);
									spent = setTimeout(spent15sec, 15000);

									resolve();
								},
							})
								.from(vars.$siteContainer, 0.5, {
									autoAlpha: 0,
									clearProps: 'all',
								});
						}
					});
			}
		});
	},
	onLeave() {
		return new Promise((resolve) => {
			new TimelineMax({
				onStart() {
				},
				onComplete() {
					vars.$page.addClass('is-hidden');

					products.destroyVideo();
					test.clear();

					resolve();
				},
			})
				.to(vars.$siteContainer, 0.5, {
					autoAlpha: 0,
					clearProps: 'all',
				});
		});
	},
});

router.addRoute({
	path: '/result',
	name: 'result',
	onEnter(prevState, currentState) {
		return new Promise((resolve) => {
			const points = currentState.query.points;
			const total = currentState.query.total;

			vars.$html.data('page', 'result').attr('data-page', 'result');
			const $page = $('.page[data-page="result"]');

			vars.$html
				.data('page', 'result')
				.attr('data-page', 'result');

			const setResult = (pointsVal, totalVal) => {
				$page.find('.test-result__value').html(pointsVal);
				$page.find('.test-result__total').html(totalVal);

				if (pointsVal < 3) {
					$page.find('.test-result__text--1').removeClass('is-hidden');
				} else if (pointsVal > 2 && pointsVal < 5) {
					$page.find('.test-result__text--2').removeClass('is-hidden');
				} else {
					$page.find('.test-result__text--3').removeClass('is-hidden');
				}
			};

			if (prevState.route) {
				if (!$page.length) {
					router.trigger('notFound', [location.pathname]);
				} else {
					new TimelineMax({
						onStart() {
							$page.removeClass('is-hidden').addClass('is-active');
							vars.$siteContainer.removeClass('is-hidden');

							setResult(points, total);
							relatedSlider.initTestSlider();
						},
						onComplete() {
							relatedSlider.updateTestSlider();

							clearTimeout(spent);
							spent = setTimeout(spent15sec, 15000);
							hit(location.pathname);
							scrollDepth.reset();
							testFinished();

							TweenMax.set(vars.$body, {clearProps: 'all'});

							resolve();
						},
					})
						.from(vars.$siteContainer, 0.5, {
							autoAlpha: 0,
							clearProps: 'all',
						});
				}
			} else {
				Promise.resolve()
					.then(() => {
						if (!$page.length) {
							router.trigger('notFound', [location.pathname]);
						} else {
							new TimelineMax({
								onStart() {
									$page.removeClass('is-hidden').addClass('is-active');
									vars.$siteContainer.removeClass('is-hidden');

									setResult(points, total);
									relatedSlider.initTestSlider();
								},
								onComplete() {
									relatedSlider.updateTestSlider();

									clearTimeout(spent);
									spent = setTimeout(spent15sec, 15000);

									TweenMax.set(vars.$body, {clearProps: 'all'});

									resolve();
								},
							})
								.from(vars.$siteContainer, 0.5, {
									autoAlpha: 0,
									clearProps: 'all',
								});
						}
					});
			}
		});
	},
	onLeave() {
		return new Promise((resolve) => {
			new TimelineMax({
				onStart() {
				},
				onComplete() {
					vars.$page.addClass('is-hidden');
					relatedSlider.destroyTestSlider();
					$('.test-result__text').removeClass('is-hidden').addClass('is-hidden');

					resolve();
				},
			})
				.to(vars.$siteContainer, 0.5, {
					autoAlpha: 0,
					clearProps: 'all',
				});
		});
	},
});

router.on('notFound', () => {
	router.navigate('/');

	return Promise.resolve();
});

router.start();

export default router;
